import { PurchaseHistoryData } from '@/features/games/shared/types/purchase-history.types';

export const isAlreadyPurchased = (
  productKey: string,
  purchaseHistory: PurchaseHistoryData | null,
): boolean => {
  if (!purchaseHistory) return false;
  const grantKeys = purchaseHistory.grantKeys || [];
  return grantKeys.some((gk) => gk.productKey === productKey);
};
